import React, { useEffect, useState } from 'react'
import ModalActionButton from '../../elements/ModalActionButton';
import { useDispatch, useSelector } from 'react-redux';
import { ERROR, SET_SUCCESS } from '../../../store/types';
import TextField from '../../elements/form/TextField';
import DateField from '../../elements/form/DateField';
import moment from 'moment';
import { clearCreatedAcademicSession, createAcademicSession } from '../../../store/actions/academicSessionsActions';

const NewAcademicSession = ({closeFunction, reload}) => {
    const dispatch = useDispatch()
    const sessionsSelector = useSelector(state => state.academicSessions)

    const [sessionPayload, setSessionPayload] = useState({});
    const [validationErrors, setValidationErrors] = useState({});

    useEffect(() => {
        if(sessionsSelector.createdAcademicSession !== null) {
            dispatch({
                type: SET_SUCCESS,
                payload: 'academic session created successfully!'
            })
            dispatch(clearCreatedAcademicSession())
            reload()
            setTimeout(() => {
                closeFunction()
            }, 50);
        }
        return () => {
            
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sessionsSelector.createdAcademicSession, dispatch, closeFunction]);

    const validateForm = () => {
        let errors = {}
        if(!sessionPayload.name || sessionPayload.name === '') {
            errors.name = true
        }
        if(!sessionPayload.startDate || sessionPayload.startDate === '') {
            errors.startDate = true
        }
        if(!sessionPayload.endDate || sessionPayload.endDate === '') {
            errors.endDate = true
        }

        setValidationErrors(errors)

        return errors
    }

    const pushSession = async () => {
        try {
            if (Object.values(validateForm()).includes(true)) {
                dispatch({
                    type: ERROR,
                    error: {response: {data: {
                        message: 'Please check the highlighted fields'
                    }}}
                })
                return
            }

            dispatch(createAcademicSession(sessionPayload))

        } catch (error) {
            console.log(error)
            dispatch({
                type: ERROR,
                error
            })
        }
    }

    return (
        <div className='w-full'>
            <div className='pb-3 border-b'>
                <p className='text-sm'>Provide the following information to create a new academic session</p>
            </div>
            <div className='mt-4'>
                <TextField
                    inputLabel="Session name/title" 
                    fieldId="fee-name" 
                    inputType="text" 
                    requiredField={true}
                    preloadValue={sessionPayload.name || ''}
                    hasError={validationErrors && validationErrors.name} 
                    returnFieldValue={(value)=>{setSessionPayload({...sessionPayload, ...{name: value}})}}
                />
            </div>

            <div className='my-2 w-full'>
                <DateField
                    inputLabel="Start Date" 
                    fieldId="start-date" 
                    requiredField={true}
                    inputType="text" 
                    preloadValue={(moment(sessionPayload.startDate).format('YYYY-MM-DD')) || ''}
                    hasError={validationErrors && validationErrors.startDate} 
                    returnFieldValue={(value)=>{
                        const formattedDate = (moment(value, 'YYYY-MM-DD').format('DD-MM-YYYY'))
                        setSessionPayload({...sessionPayload, ...{startDate: formattedDate}})
                    }}
                />
            </div>

            <div className='my-2 w-full'>
                <DateField
                    inputLabel="End Date" 
                    fieldId="end-date" 
                    requiredField={true}
                    inputType="text" 
                    preloadValue={(moment(sessionPayload.endDate).format('YYYY-MM-DD')) || ''}
                    hasError={validationErrors && validationErrors.endDate} 
                    returnFieldValue={(value)=>{
                        const formattedDate = (moment(value, 'YYYY-MM-DD').format('DD-MM-YYYY'))
                        setSessionPayload({...sessionPayload, ...{endDate: formattedDate}})
                    }}
                />
            </div>

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Create session`}
                    buttonAction={()=>{pushSession()}}
                    processing={sessionsSelector.creatingAcademicSession}
                 />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={closeFunction}
                >
                    Cancel
                </button>
                
            </div>
        </div>
    )
}

export default NewAcademicSession